module.exports = __webpack_public_path__ + "img/shop_storage_3.c1d0a5ae.jpg";